module.exports = __webpack_public_path__ + "img/icon_stop.2a67c1f8.svg";